module.exports = __webpack_public_path__ + "img/knausgaard_Min_kamp2.5c0c4640.jpg";